// extracted by mini-css-extract-plugin
export var banner = "_fj-0";
export var closeButton = "_fj-2";
export var greenCheckmark = "_fj-3";
export var hereLink = "_fj-4";
export var titleIcon = "_fj-1";